import React, { useContext, useState } from "react";
import { UserContext } from "../../Context/UserContext";
import MyInput from "../../Reusable/MyInput";
import Button from "../../Reusable/Button";
import DivisionPageForm from "../../masterFormPages/DivisionPageForm";
import toast from "react-hot-toast";
import { BaseURL } from "../../Reusable/BaseURL";

export default function Division() {
  const { darkTheme, loginData, allPermiss } = useContext(UserContext);
  const [divisionName, setDivisionName] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  // create Division
  async function createDivision(e) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("name", divisionName);
    setSubmitDisable(true);
    const formData = {
      name: divisionName,
    };

    const res = await fetch(`${BaseURL}/divisions`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        // Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          firstPageList();
          toast.success("Success");
          setDivisionName("");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.name) {
          toast.error(createRes.error.message.name);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/divisions?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((divisionList) => {
        if (divisionList?.status) {
          const revData = divisionList.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(divisionList.data.total);
          setLinks(divisionList.data.links);
          setFrom(divisionList.data.from);
          setTo(divisionList.data.to);
          setSpinner(false);
        }
      });
  }

  function editBtn(editData) {
    if (editData) {
      setEditDisable(true);
      setSubmitAction("update");
      setDivisionName(editData.name || "");
      setEditDisable(false);

      // TOP SCROLLING ==========
      // const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // You can use 'auto' instead of 'smooth' for instant scrolling
      });
      // };
      toast.success("Go to update form");
    }
  }
  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    const formData = { name: divisionName };
    const updRes = await fetch(`${BaseURL}/divisions/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({name: divisionName}),
    })
      .then((res) => res.json())
      .then((upd) => {
        if (upd.status) {
          firstPageList();
          setGetId(0);
          toast.success("Updated");
          setDivisionName("");
          setSubmitAction("submit");
          setUpdateDisable(false);
        }
        if (upd.status === false) {
          setUpdateDisable(false);
        }
        if (upd?.error?.message.name) {
          toast.error(upd.error.message.name);
        }
      });
  }

  function cancelFun() {
    setSubmitAction("submit");
    setDivisionName("");
    setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false);
    setEditDisable(false);
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Division Master
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col justify-between gap-8 md:flex-row md:gap-1 lg:gap-4"
          >
            {allPermiss?.includes("master-division-create") && (
              <div className="w-full px-2 md:w-[40%]">
                <div className="font-medium text-[16px] my-5">
                  Create Division Name
                </div>
                <form action="">
                  <MyInput
                    label="Division Name"
                    type="text"
                    value={divisionName}
                    onChange={(e) => setDivisionName(e.target.value)}
                    className="w-[260px] md:w-[300px] lg:w-[360px] block"
                    mendatory="*"
                  />

                  {allPermiss?.includes("master-division-create") &&
                    submitAction === "submit" && (
                      <div className="flex items-center justify-start gap-x-1">
                        <Button
                          disabled={submitDisable}
                          type="submit"
                          onClick={(e) => createDivision(e)}
                        >
                          {submitDisable ? "Wait.." : "Submit"}
                        </Button>
                        <Button type="button" onClick={() => cancelFun()}>
                          Clear
                        </Button>
                      </div>
                    )}
                  {allPermiss?.includes("master-division-update") &&
                    submitAction === "update" && (
                      <div className="flex items-center justify-start gap-x-1">
                        <Button
                          disabled={updateDisable}
                          type="submit"
                          onClick={(e) => updateARecord(e, getId)}
                        >
                          {updateDisable ? "Wait.." : "Update"}
                        </Button>
                        <Button onClick={() => cancelFun()} type="button">
                          Cancel
                        </Button>
                      </div>
                    )}
                </form>

                <div className="px-3 mt-6 mb-4">
                  <div className="font-medium text-[16px] mb-2">Division</div>
                  <p>
                    Division is used for Item category, Every items having
                    division like OIL , RUBBER , IRON etc. its useful while you
                    search or filter items.
                  </p>
                </div>
              </div>
            )}

            {allPermiss?.includes("master-division-view") && (
              <div className="w-full px-2 md:w-[60%]">
                <DivisionPageForm
                  editBtn={editBtn}
                  firstPageList={firstPageList}
                  links={links}
                  firstPage={firstPage}
                  setGetId={setGetId}
                  spinner={spinner}
                  totalNo={totalNo}
                  from={from}
                  to={to}
                  editDisable={editDisable}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
